import React, { createContext, useContext, useLayoutEffect, useState } from 'react'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import { ThemeType } from '../../themes/themes'
import { NormalizeCSS } from '../NormalizeCSS/NormalizeCSS'
import './_importFonts.css'

const swashbuckleCache = createCache({ 
  key: 'homebot',
  prepend: true
})

interface ThemeProviderProps {
  theme?: ThemeType,
  children: JSX.Element
}

const emptyTheme: ThemeType = {
  name: undefined, 
  tokens: {}, 
  isLightThemeType: false 
}

const ThemeContext = createContext<{
  theme: ThemeType,
  setTheme: React.Dispatch<React.SetStateAction<ThemeType>>
}>({
  theme: emptyTheme,
  setTheme: () => null
})

export const ThemeProvider = ({ children, theme: initialTheme = emptyTheme }: ThemeProviderProps) => {
  const [theme, setTheme] = useState(initialTheme)

  useLayoutEffect(() => {
    const { tokens } = theme

    Object.keys(tokens).forEach((token) => {
      document.documentElement.style.setProperty(`--${token}`, tokens[token])
    })

    return () => {
      Object.keys(tokens).forEach((token) => {
        document.documentElement.style.removeProperty(`--${token}`)
      })
    }
  }, [theme.name])

  useLayoutEffect(() => {
    setTheme(initialTheme || emptyTheme)
  }, [initialTheme.name])
 
  return (
    <CacheProvider value={swashbuckleCache}>
      <ThemeContext.Provider value={{
        setTheme,
        theme
      }}>
        <NormalizeCSS />
        {children}
      </ThemeContext.Provider>
    </CacheProvider>
  )
}

export const useTheme = () => {
  return useContext(ThemeContext)
}